/* eslint-disable better-mutation/no-mutation */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import GdprSettings from 'tradera/utils/gdpr-settings';
import cookieUtil from 'tradera/utils/cookie';
import {
    WISH_LIST_NOTIFICATION_DISPLAY_COUNT,
    WISH_LIST_NOTIFICATION_HIDDEN
} from 'tradera/constants/cookies';

const slice = createSlice({
    name: 'wishListNudge',
    initialState: { wishListNudgeHidden: false },
    reducers: {
        shouldShowWishListNudge: {
            reducer: (
                state,
                action: PayloadAction<{ wishListNudgeHidden: boolean }>
            ) => {
                const { payload } = action;
                state.wishListNudgeHidden = payload.wishListNudgeHidden;
            },
            prepare: () => {
                const isHidden =
                    cookieUtil.readCookie(WISH_LIST_NOTIFICATION_HIDDEN) ===
                        'true' || GdprSettings.isFunctionalEnabled() === false;

                if (isHidden) return { payload: { wishListNudgeHidden: true } };
                return { payload: { wishListNudgeHidden: false } };
            }
        },
        hideWishListNudge: {
            reducer: (state) => {
                state.wishListNudgeHidden = true;
            },
            prepare: () => {
                cookieUtil.createCookie(
                    WISH_LIST_NOTIFICATION_HIDDEN,
                    true,
                    Infinity
                );
                cookieUtil.eraseCookie(WISH_LIST_NOTIFICATION_DISPLAY_COUNT);
                return { payload: {} };
            }
        }
    }
});

export const { shouldShowWishListNudge, hideWishListNudge } = slice.actions;

export const wishListNudge = slice.reducer;
